export const strings = {
  title: 'Edit rule',
  editRuleText: 'Please use the pre-populated input box to edit this rule and drag it into the correct corresponding category. To apply the same apportionment simply drag it into the split between different categories box and you will be show the original apportionment.',
  currentApportionmentText: 'Current Apportionment',
  currentPriorityText: 'Current Priority',
  notes: 'Notes:',
  additionalDisclosure: 'Additional Disclosure',
};